export default {"src":"/_next/static/media/Critical.a904a3ec.svg","height":10,"width":12,"blurWidth":0,"blurHeight":0};